import React from 'react'
import { Col, Dropdown, Form, InputGroup, Nav, Row, Tab } from 'react-bootstrap'

import DashboardCalendar from '@components/pages/Dashboard/DashboardCalendar.component'
import {
  Production,
  Collections,
  FluorideTreatment,
} from '@components/pages/Dashboard/ProviderPulse'

import '../../components/pages/Dashboard/DashboardStyle.css'

interface NavItem {
  eventKey: string
  title: string
}

interface NavItems {
  [key: string]: NavItem[]
}

const NAV_ITEMS: NavItems = {
  production: [
    {
      eventKey: 'production',
      title: 'Production',
    },
    {
      eventKey: 'same-day-prod',
      title: 'Same Day Production %',
    },
    {
      eventKey: 'prod-per-hour',
      title: 'Production Per Hour',
    },
    {
      eventKey: 'prod-per-day',
      title: 'Production Per Day',
    },
    {
      eventKey: 'prod-per-visit',
      title: 'Production Per Visit',
    },
  ],
  collections: [
    {
      eventKey: 'collections',
      title: 'Collections',
    },
  ],
  hygiene: [
    {
      eventKey: 'perio-diagnostic',
      title: 'Perio Diagnostic %',
    },
    {
      eventKey: 'perio-acceptance',
      title: 'Perio Acceptance %',
    },
    {
      eventKey: 'perio-visit',
      title: 'Perio Visit %',
    },
    {
      eventKey: 'hygienist-per-hour',
      title: 'Hygienist Per Hour',
    },
    {
      eventKey: 'hygiene-re-appointment',
      title: 'Hygiene Re-Appointment %',
    },
    {
      eventKey: 'np-hygiene-re-appointment',
      title: 'NP Hygiene Re-Appointment %',
    },
    {
      eventKey: 'fluoride-treatment',
      title: 'Fluoride Treatment %',
    },
  ],
}

const NAV_TITLES = [
  {
    key: 'production',
    title: 'Production',
    icon: 'bi bi-box-seam',
  },
  {
    key: 'collections',
    title: 'Collections',
    icon: 'bi bi-collection ',
  },
  {
    key: 'hygiene',
    title: 'Hygiene',
    icon: 'bi bi-journal-medical',
  },
]

function ProviderPulse(): React.ReactElement {
  return (
    <>
      <Tab.Container defaultActiveKey={'production'}>
        <Row>
          <hr className="mt-2 mb-2" />
          <Col md={3}>
            <DashboardCalendar classNameCalendar="calendar-provider-pulse" />
          </Col>
          <Col md={9} className="">
            <Nav className="justify-content-end custom-btn-drpdwn">
              {NAV_TITLES.map(({ key, title, icon }) => (
                <Dropdown key={key} className="">
                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                    <i className={`${icon} me-2`}></i>
                    {title}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Divider />
                    <Nav className="flex-column">
                      {NAV_ITEMS[key].map((item, index) => (
                        <Nav.Item key={`${item}-${index}`} className="">
                          <Nav.Link eventKey={item.eventKey}>
                            <i className="bi bi-chevron-right me-2"></i>
                            {item.title}
                          </Nav.Link>
                        </Nav.Item>
                      ))}
                    </Nav>
                  </Dropdown.Menu>
                </Dropdown>
              ))}
            </Nav>
          </Col>
          <hr className="mt-2" />
        </Row>
        <Row>
          <Col md={12}>
            <Row>
              <Col md={2} className="colDDFilter">
                <Form.Group className="mb-1">
                  <Form.Label className="label-top">Role</Form.Label>
                  <InputGroup>
                    <Form.Select
                      // value={selectedCategory}
                      // onChange={(e) => setSelectedCategory(e.target.value)}
                      className="form-control"
                    >
                      <option value="">All Roles Selected</option>
                    </Form.Select>
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col md={2} className="colDDFilter">
                <Form.Group className="mb-1">
                  <Form.Label className="label-top">Providers</Form.Label>
                  <InputGroup>
                    <Form.Select
                      // value={selectedCategory}
                      // onChange={(e) => setSelectedCategory(e.target.value)}
                      className="form-control"
                    >
                      <option value="">All Providers Selected</option>
                    </Form.Select>
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col md={2} className="colDDFilter">
                <Form.Group className="mb-1">
                  <Form.Label className="label-top">Production Type</Form.Label>
                  <InputGroup>
                    <Form.Select
                      // value={selectedCategory}
                      // onChange={(e) => setSelectedCategory(e.target.value)}
                      className="form-control"
                    >
                      <option value="">Gross Production</option>
                    </Form.Select>
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>
          </Col>
          <Col md={12}>
            <Tab.Content>
              <Tab.Pane eventKey={'production'}>
                <Production />
              </Tab.Pane>
              <Tab.Pane eventKey={'collections'}>
                <Collections />
              </Tab.Pane>
              <Tab.Pane eventKey={'fluoride-treatment'}>
                <FluorideTreatment />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </>
  )
}

export default ProviderPulse
